module.exports = __webpack_public_path__ + "img/delete-bin.97e2f705.svg";